'use client';

import cn from 'classnames';
import { ComponentRef, forwardRef } from 'react';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import { Field, FieldDescription, FieldError, FieldLabel, RadioGroupProps } from '@/shared/ui/core';
import styles from './radio-group.module.scss';


export const RadioGroup = forwardRef<ComponentRef<typeof RadioGroupPrimitive.Root>, RadioGroupProps>(function RadioGroup ({
    className,
    wrapperClassName,
    label,
    description,
    error,
    state = 'default',
    disabled,
    ...props
}, ref) {
    const isError       = state === 'error' || Boolean(error);
    const isSuccess     = state === 'success';
    const isWarning     = state === 'warning';
    const isDefault     = state === 'default';
    const textClassname = cn({
        [styles.default]    : isDefault,
        [styles.destructive]: isError,
        [styles.success]    : isSuccess,
        [styles.warning]    : isWarning,
        [styles.disabled]   : disabled,
    });

    return (
        <Field className={ cn(styles.field, wrapperClassName) }>
            {
                label &&
                <FieldLabel
                    className={ textClassname }
                    required={ props.required }
                >
                    { label }
                </FieldLabel>
            }

            <RadioGroupPrimitive.Root
                ref={ ref }
                disabled={ disabled }
                aria-invalid={ isError }
                className={ cn(styles.root, className) }
                { ...props }
            />

            {
                isError &&
                error &&
                <FieldError className={ textClassname }>
                    { error }
                </FieldError>
            }

            {
                !isError &&
                description &&
                <FieldDescription className={ textClassname }>
                    { description }
                </FieldDescription>
            }
        </Field>
    );
});
